export enum MediaTypeEnum {
  image = 0,
  video = 1,
  favicon = 2,
  logo = 3,
}
